import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticStyle:{"max-width":"1600px"},attrs:{"fluid":"","grid-list-lg":""}},[(_vm.isLoading)?_c(VProgressLinear,{staticStyle:{"z-index":"6"},attrs:{"color":"warning","indeterminate":"","rounded":"","height":"3","fixed":"","top":""}}):_vm._e(),_c(VLayout,{attrs:{"wrap":""}},[_c(VFlex,{staticClass:"d-flex align-center"},[_c('h1',[_vm._v("System Actions")])])],1),(_vm.client && _vm.client.id  && _vm.load)?_c('system-actions',{attrs:{"clientId":_vm.client.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }